<template>
  <div class="w-full">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-w="12" class="px-2">
        <div id="forca_horario_card" class="vs-con-loading__container">
          <vx-card class="w-full">
            <div>
              <vs-row vs-w="12" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="9" class="">
                  <h5>Gerenciar Força</h5>
                  <p class="text-grey mt-1">
                    Informe a força de trabalho disponível por dia da semana e
                    horário: horas de manutenção, horas de força inicial e
                    veículos disponíveis (carros e motos). O total de rotas
                    disponíveis é calculado automaticamente a partir dos
                    veículos informados.
                  </p>
                </vs-col>
                <vs-col vs-w="3" vs-justify="right" vs-align="right" class="px-2">
                  <vs-button
                    size="small"
                    color="success"
                    type="relief"
                    :disabled="!$atividades.permissoes.includes(14)"
                    @click="salvarForcaHorarios()"
                    >Salvar</vs-button
                  >
                </vs-col>
              </vs-row>
            </div>
            <div class="w-full mt-4 dias-semana-tabs">
              <vs-button
                v-for="dia in diasSemana"
                :key="dia.id"
                size="small"
                class="mr-2 mb-2"
                :type="dia.id === diaSelecionado ? 'filled' : 'border'"
                :color="dia.id === diaSelecionado ? 'success' : 'dark'"
                @click="selecionarDia(dia.id)"
                >{{ dia.nome }}</vs-button
              >
            </div>
            <div class="w-full mt-4" style="overflow-x: auto">
              <table class="w-full forca-horario-table">
                <thead>
                  <tr>
                    <th>Horário</th>
                    <th>Horas Manutenção</th>
                    <th>Horas Inicial</th>
                    <th>Qtd. Carros</th>
                    <th>Qtd. Motos</th>
                    <th>Rotas Disponíveis</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="horario in horarios" :key="horario.horario">
                    <td>
                      <strong>{{ formatarHorario(horario.horario) }}</strong>
                    </td>
                    <td>
                      <vs-input
                        type="number"
                        min="0"
                        size="small"
                        v-model.number="horario.horas_manutencao"
                      ></vs-input>
                    </td>
                    <td>
                      <vs-input
                        type="number"
                        min="0"
                        size="small"
                        v-model.number="horario.horas_inicial"
                      ></vs-input>
                    </td>
                    <td>
                      <vs-input
                        type="number"
                        min="0"
                        size="small"
                        v-model.number="horario.qtd_carros"
                      ></vs-input>
                    </td>
                    <td>
                      <vs-input
                        type="number"
                        min="0"
                        size="small"
                        v-model.number="horario.qtd_motos"
                      ></vs-input>
                    </td>
                    <td>
                      <strong>{{ rotasDisponiveis(horario) }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </vx-card>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  data() {
    return {
      horarios: [],
      diaSelecionado: 0,
      diasSemana: [
        { id: 0, nome: "Segunda" },
        { id: 1, nome: "Terça" },
        { id: 2, nome: "Quarta" },
        { id: 3, nome: "Quinta" },
        { id: 4, nome: "Sexta" },
        { id: 5, nome: "Sábado" },
        { id: 6, nome: "Domingo" },
      ],
    };
  },
  methods: {
    formatarHorario(horario) {
      return String(horario).padStart(2, "0") + "h";
    },
    rotasDisponiveis(horario) {
      const carros = horario.qtd_carros || 0;
      const motos = horario.qtd_motos || 0;
      return carros + motos;
    },
    montarHorariosPadrao() {
      const horarios = [];
      for (let i = 0; i < 24; i++) {
        horarios.push({
          horario: i,
          horas_manutencao: 0,
          horas_inicial: 0,
          qtd_carros: 0,
          qtd_motos: 0,
        });
      }
      return horarios;
    },
    async selecionarDia(dia) {
      this.diaSelecionado = dia;
      await this.getForcaHorarios();
    },
    async getForcaHorarios() {
      await this.$vs.loading({ container: "#forca_horario_card", scale: 0.6 });
      try {
        const horarios = this.montarHorariosPadrao();
        const res = await this.$http.get(
          `forca_horario?dia_semana=${this.diaSelecionado}`
        );
        for (const salvo of res) {
          const index = horarios.findIndex((h) => h.horario === salvo.horario);
          if (index !== -1) {
            horarios[index] = {
              horario: salvo.horario,
              horas_manutencao: salvo.horas_manutencao,
              horas_inicial: salvo.horas_inicial,
              qtd_carros: salvo.qtd_carros,
              qtd_motos: salvo.qtd_motos,
            };
          }
        }
        this.horarios = horarios;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#forca_horario_card > .con-vs-loading");
      }
    },
    async salvarForcaHorarios() {
      await this.$vs.loading({ container: "#forca_horario_card", scale: 0.6 });
      try {
        await this.$http.post("forca_horario", {
          dia_semana: this.diaSelecionado,
          horarios: this.horarios,
        });
        this.$vs.notify(this.$notify.Success);
        await this.getForcaHorarios();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#forca_horario_card > .con-vs-loading");
      }
    },
  },
  async mounted() {
    await this.getForcaHorarios();
  },
  components: {
    ...components,
  },
};
</script>

<style scoped>
.forca-horario-table {
  border-collapse: collapse;
}
.forca-horario-table th,
.forca-horario-table td {
  padding: 6px 10px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  white-space: nowrap;
}
.forca-horario-table .vs-input {
  width: 110px;
}
</style>
